import { render } from "./ModalWelcome.vue?vue&type=template&id=4d68b3c6&scoped=true"
import script from "./ModalWelcome.vue?vue&type=script&lang=js"
export * from "./ModalWelcome.vue?vue&type=script&lang=js"

import "./ModalWelcome.vue?vue&type=style&index=0&id=4d68b3c6&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d68b3c6"]])

export default __exports__